import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";

import { appLabel } from "./labels";

// The app's name as a link that opens it in the tenant, in a new tab. An app
// the collection never saw by name (deleted before the first collection) only
// has its id, so it stays plain text.
export function QlikAppLink({
  app,
  baseUrl,
}: {
  app: { appId: string; appName: string | null };
  baseUrl: string;
}) {
  const { t } = useTranslation("reloads");
  const label = appLabel(app);
  if (app.appName === null) return <span title={label}>{label}</span>;
  return (
    <a
      href={`${baseUrl.replace(/\/$/, "")}/sense/app/${encodeURIComponent(app.appId)}`}
      target="_blank"
      rel="noopener noreferrer"
      title={t("openInQlik", { name: label })}
      className="inline-flex max-w-full items-center gap-1 hover:underline"
    >
      <span className="truncate">{label}</span>
      <ArrowUpRight className="size-3 shrink-0" aria-hidden />
    </a>
  );
}
